import { IAuction, IOffer } from '@kaaja/data-models';
import { AUCTION_STATUSES } from '../models/constants';

export const getCurrentBid = (
  auction: Pick<IAuction, 'highestBid' | 'startingPrice'>
) =>
  auction.highestBid
    ? auction.highestBid.offer.amount
    : auction.startingPrice.amount;

export const getAuctionBid = (
  auction: Pick<
    IAuction,
    'highestBid' | 'startingPrice' | 'status' | 'buyNow'
  > & {
    buyNowPrice: IOffer | null;
  }
): number | null => {
  switch (auction.status) {
    case AUCTION_STATUSES.CREATED:
    case AUCTION_STATUSES.RUNNING:
    case AUCTION_STATUSES.UNDER_EVALUATION:
      return getCurrentBid(auction);
    case AUCTION_STATUSES.BUY_NOW_UNDER_EVALUATION:
    case AUCTION_STATUSES.BUY_NOW_ONLY_UNDER_EVALUATION:
    case AUCTION_STATUSES.ONLY_BUY_NOW:
    case AUCTION_STATUSES.COMING_SOON:
      return auction.buyNowPrice ? auction.buyNowPrice.amount : null;
    case AUCTION_STATUSES.CLOSED_WITH_NO_BIDS:
    case AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_MET:
    case AUCTION_STATUSES.CLOSED_WITH_WINNER_AND_RESERVED_PRICE_NOT_MET:
    case AUCTION_STATUSES.SOLD:
    case AUCTION_STATUSES.SOLD_FOR_BUY_NOW:
    case AUCTION_STATUSES.NOT_SOLD:
      return null;
  }
};
